"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorSlider = void 0;
var Utilities_1 = require("../../../Utilities");
var ColorSlider_base_1 = require("./ColorSlider.base");
var ColorSlider_styles_1 = require("./ColorSlider.styles");
exports.ColorSlider = (0, Utilities_1.styled)(ColorSlider_base_1.ColorSliderBase, ColorSlider_styles_1.getStyles, undefined, { scope: 'ColorSlider' });
//# sourceMappingURL=ColorSlider.js.map